// src/components/InsightsCard.js

import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
    Card,
    CardContent,
    CardHeader,
    CardActions,
    Typography,
    Box,
    useTheme,
    IconButton,
    Avatar,
} from '@mui/material';
import XIcon from '@mui/icons-material/X';
import {
    Facebook as FacebookIcon,
    Instagram as InstagramIcon,
    LinkedIn as LinkedInIcon,
    TrendingUp as TrendingUpIcon,
} from '@mui/icons-material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';

const InsightsCard = () => {
    const theme = useTheme();

    // Define gradient backgrounds for light and dark modes
    const gradientBackground =
        theme.palette.mode === 'dark'
            ? 'linear-gradient(to bottom right, #2563EB, #1E3A8A)' // Darker blues for dark mode
            : 'linear-gradient(to bottom right, #2563EB, #60A5FA)'; // Lighter blues for light mode

    // Common badge style
    const badgeStyle = {
        display: 'inline-flex',
        alignItems: 'center',
        borderRadius: '9999px',
        px: 1.5,
        py: 0.5,
        fontSize: '0.75rem',
        fontWeight: 'bold',
        backgroundColor: 'rgba(255, 255, 255, 0.2)',
        color: '#FFFFFF',
    };

    return (
        <Card
            sx={{
                position: 'relative',
                overflow: 'hidden',
                backgroundImage: gradientBackground,
                color: '#FFFFFF',
                borderRadius: '12px',
                height: "100%",
                textDecoration: 'none',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                    transform: 'translateY(-10px)',
                    boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
                },
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
            }}
        >
            
            <CardContent sx={{ p: 3 }}>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                    <Avatar sx={{ mr: 0.5, backgroundColor: 'transparent', width: 56, height: 56 }}>

                        <TrendingUpIcon sx={{ color: '#FFFFFF' }} />
                    </Avatar>
                    <Typography variant="h5" sx={{ color: '#FFFFFF', fontWeight: 'bold' }}>
                        Insights
                    </Typography>
                </Box>

                {/* Metrics */}
                <Box sx={{ mt: 2 }}>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                        <Typography variant='body2' sx={{ color: '#FFFFFF' }}>Total Reach</Typography>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                            -
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                    <Typography variant='body2' sx={{ color: '#FFFFFF' }} >Engagement Rate</Typography>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                            -
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <Typography variant='body2' sx={{ color: '#FFFFFF' }}>Growth</Typography>
                        <Typography variant='body2' sx={{ fontWeight: 'bold', color: '#FFFFFF' }}>
                            -
                        </Typography>
                    </Box>
                </Box>
            </CardContent>

            {/* Link Button */}
            <CardActions sx={{ justifyContent: 'space-between', pt: "48px", }}>
                {/* Badges for Social Media Platforms */}
                <Box sx={{ mb: 2, display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                    <Box sx={badgeStyle}>
                        <FacebookIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
                        Facebook
                    </Box>
                    <Box sx={badgeStyle}>
                        <XIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
                        X
                    </Box>
                    <Box sx={badgeStyle}>
                        <InstagramIcon sx={{ fontSize: '0.75rem', mr: 0.5 }} />
                        Instagram
                    </Box>
                    
                </Box>
                <IconButton
                    component={RouterLink}
                    to='/pinsights'
                    sx={{
                        color: '#FFFFFF',
                        backgroundColor: 'rgba(255, 255, 255, 0.2)',
                        '&:hover': {
                            backgroundColor: 'rgba(255, 255, 255, 0.3)',
                        },
                    }}
                >
                    <ArrowForwardIcon />
                </IconButton>
            </CardActions>
        </Card>
    );
};

export default InsightsCard;
